import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { ManifestosPainelComponent } from '../manifestos-painel.component';
import { ManifestoService } from 'src/app/services/manifesto/manifesto.service';

@Component({
  selector: 'app-modal-manifesto-solicitacao-prorrogacao-sla',
  templateUrl: './modal-manifesto-solicitacao-prorrogacao-sla.component.html',
  styleUrls: ['./modal-manifesto-solicitacao-prorrogacao-sla.component.scss']
})
export class ModalManifestoSolicitacaoProrrogacaoSlaComponent implements OnInit {
  public items: any;
  private isDevolucao;
  public isLoading = false;
  public numero: string;
  public dataBaixa: string;
  public dataSLAAtual: string;

  public form: FormGroup = new FormGroup({
    dataFinal: new FormControl(),
    horaFinal: new FormControl(),
    justificativa: new FormControl(),
  });

  get justificativa() { return this.form.get("justificativa").value;}
  get dataFinal() { return this.form.get("dataFinal").value;}
  get horaFinal() { return this.form.get("horaFinal").value;}

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private manifestoService: ManifestoService,
    private dialogRef: MatDialogRef<ManifestosPainelComponent>,
    public snackBar: MatSnackBar
  ) { 
    this.items = data.item;
    this.isDevolucao = data.item.isDevolucao;
    console.log('---->', JSON.stringify(data.item));
    this.numero = this.items.item.numeroManifesto;
    this.dataBaixa = this.transformDate(this.items.item.dtBaixa);
    this.dataSLAAtual = this.transformDate(this.items.item.dtVencRessalva);
  }

  ngOnInit() {
  }

  public salvar() {   

    if (!this.dataFinal) {
      this.openSnackBar('Preencha a Data Final!', 'OK', 5000);
      return;      
    }
    if (!this.horaFinal) {
      this.openSnackBar('Preencha a Hora Final!', 'OK', 5000);
      return;      
    }
    if (!this.justificativa) {
      this.openSnackBar('Preencha a justificativa!', 'OK', 5000);
      return;
    }

    let convertDate = this.dataFinal ? this.dataFinal.toISOString().split('T')[0] : null;

    if (Date.parse(`${convertDate} ${this.horaFinal}`) < Date.now()) {
      this.openSnackBar('A data final e a hora final não podem ser menor que o dia atual!', 'OK', 5000);
      return;        
    }

    if (Date.parse(`${convertDate} ${this.horaFinal}`) < Date.parse(this.items.item.dtVencRessalva)) {
      this.openSnackBar('A data final e a hora final não podem ser menor que a do SLA Atual!', 'OK', 5000);
      return;        
    }

    let obj = {
      manifestoId: this.items.item.numeroManifesto,
      isDevolucao: this.isDevolucao,
      dtSolicitada: `${convertDate}T${this.horaFinal}`,
      justificativa: this.justificativa
    }

    this.manifestoService.salvarJustificativaAprovacao(obj)
    .pipe(take(1)).
    subscribe(
      (response: HttpResponse<any>) => { 
        this.dialogRef.close(response);
        this.openSnackBar('Justificativa salva com sucesso!', 'Ok', 5000); 
      },
      () => {
        this.openSnackBar('Erro ao salvar justificativa!', 'OK', 5000, 'danger-snackbar');
      });    
  }

  transformDate(value: string) {
    var datePipe = new DatePipe("en-BR"); 
     value = datePipe.transform(value, 'dd/MM/yyyy HH:mm');
     return value;
 }


  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
